import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Concept from "@/components/landing/Concept";
import Gallery from "@/components/landing/Gallery";
import WorldMap from "@/components/landing/WorldMap";
import Footer from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ anchors: true, lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <div className="App overflow-x-clip bg-sky font-sans text-navy" data-testid="landing-page">
      <div className="grain-overlay" aria-hidden="true" />
      <Hero />
      <Marquee />
      <Concept />
      <Gallery />
      <WorldMap />
      <Footer />
    </div>
  );
}

export default App;
